import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { BillingMode, DeviceInfoSetting, DeviceOS, KeyValues5, KeyValueSet, LocalService, LocalWeightMachineName, Status } from 'src/service/local.service';

@Component({
  selector: 'app-config-ui-device',
  templateUrl: './config-ui-device.component.html',
  styleUrl: './config-ui-device.component.scss'
})
export class ConfigUiDeviceComponent {
  @ViewChild('content_config_ui_device')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() title: string = ''; @Input() weightMachines: LocalWeightMachineName[] = []; @Input() id: string = ''; @Input() businessId: string = '';
  item: DeviceInfoSetting; osTypes: KeyValueSet[] = []; billingModes: KeyValueSet[] = [];
  @Input() printers: KeyValues5[];

  htmlId: string = ''; elementIds: any; sideBarBodyHeight: number = 10;

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private configurationManagementService: ConfigurationManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      btn_navigate: 'btn_navigate_' + this.htmlId + '_',
      txt_quick_search: 'txt_quick_search_' + this.htmlId
    }
  }

  ngOnInit(): void {
    this.osTypes = Object.keys(DeviceOS)
      .map(function (x) {
        return {
          key: x.toString(),
          value: DeviceOS[parseInt(x)]
        } as KeyValueSet;
      }).filter(x => x.key && x.value && x.key != '0');

    this.billingModes = Object.keys(BillingMode)
      .map(function (x) {
        return {
          key: x.toString(),
          value: BillingMode[parseInt(x)]
        } as KeyValueSet;
      }).filter(x => x.key && x.value && x.key != '0');
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onReset() {
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.sideBarBodyHeight = window.outerHeight - 150;
    this.configurationManagementService.getDeviceInfoSetting(this.id, this.businessId).subscribe(result => {
      this.item = result;
      this.item.DeviceOs = this.item.DeviceOs.toString();
      this.item.BillingMode = this.item.BillingMode.toString();
    });
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        if (!(this.item.Title && this.item.Title.trim().length > 0)) {
          return;
        }

        if (this.item.DirectPrintUrl && this.item.DirectPrintUrl.length > 5 && !this.item.DirectPrintUrl.endsWith('/')) {
          this.item.DirectPrintUrl = this.item.DirectPrintUrl + '/';
        }

        if (this.item.DirectWeightMachineUrl && this.item.DirectWeightMachineUrl.length > 5 && !this.item.DirectWeightMachineUrl.endsWith('/')) {
          this.item.DirectWeightMachineUrl = this.item.DirectWeightMachineUrl + '/';
        }

        this.configurationManagementService.saveDeviceInfoSetting(this.item).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success) {
            this.onCloseTrigger();
          }
        });
      } break;
    }
  }

  onOsSelected() {
    switch (this.item.DeviceOs) {
      case DeviceOS.Android.toString(): {
        this.item.DirectPrintUrl = "http://127.0.0.1:3012/";
        this.item.DirectWeightMachineUrl = "http://127.0.0.1:3012/";
        this.item.BillingMode = BillingMode.QuickPick.toString();
        this.item.IsCompactViewInBillingMode = true;
        this.item.IsCompactViewInSalesReport = true;
      } break;
    }
  }
}
